export default __webpack_public_path__ + "static/media/4 - Thieving.140bb64a.mp3";